import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import {
  GetIconCssClassPipe,
  PropertyTranslatorPipe,
} from '@osos/shared/utility';
import { ButtonModule } from 'primeng/button';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { NoAccessComponent } from './no-access/no-access.component';
import { RefreshComponent } from './refresh/refresh.component';
import { SplashScreenComponent } from './splash-screen/splash-screen.component';
import { WelcomePageComponent } from './welcome-page/welcome-page.component';

@NgModule({
  declarations: [
    AuthCallbackComponent,
    WelcomePageComponent,
    NoAccessComponent,
    RefreshComponent,
    SplashScreenComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    GetIconCssClassPipe,
    PropertyTranslatorPipe,
    ButtonModule,
  ],
  exports: [SplashScreenComponent],
})
export class PagesModule {}
